export enum ButtonType {
    View = "View",
    Edit = "Edit",
    Cancel = "Cancel",
    Apply = "Apply"
}